export default __webpack_public_path__ + "static/media/kill-the-zeros-tile.6b49328b.png";